class slopeNoFormat {
  static FeatureNo13Char(pFeatureNo) {
    var mResult = pFeatureNo.toUpperCase();
    pFeatureNo = pFeatureNo.toUpperCase();

    try {
      pFeatureNo = pFeatureNo.split(" ").join("");
      var mIndex1 = pFeatureNo.indexOf("-");
      var mIndex2 = pFeatureNo.indexOf("/");
      var mIndex3;

      var mPart1 = "";
      var mPart2 = "";
      var mPart3 = "";
      var mPart4 = "";
      var mPart5 = "";

      mPart1 = pFeatureNo.substr(0, mIndex1 - 2);
      mPart2 = pFeatureNo.substr(mIndex1 - 2, 2);
      mPart3 = pFeatureNo.substr(mIndex1 + 1, 1);
      for (let i = mIndex2 + 1; i < pFeatureNo.length; i++) {
        var mTemp = pFeatureNo.substr(i, 1);
        if (!isNaN(mTemp)) {
          mPart4 = pFeatureNo.substr(mIndex2 + 1, i - mIndex2 - 1);
          mIndex3 = i;
          break;
        }
      }
      mPart5 = pFeatureNo.substr(mIndex3);

      mPart1 = "  " + mPart1;
      mPart1 = mPart1.substr(mPart1.length - 2);
      mPart4 = mPart4 + "  ";
      mPart4 = mPart4.substr(0, 2);
      mPart5 = "    " + mPart5;
      mPart5 = mPart5.substr(mPart5.length - 4);

      mResult = mPart1 + mPart2 + "-" + mPart3 + "/" + mPart4 + mPart5;
    } catch (err) {}

    return mResult;
  }
}
export default slopeNoFormat;
